import { type Chain as WagmiChain } from 'wagmi/chains';
import * as wagmiChains from 'wagmi/chains';
import { type AnyChainflipChainData, type ChainflipChainData } from '.';

export const bitcoin = {
  id: 'btc',
  name: 'Bitcoin',
  addressPlaceholder: '',
  wagmiChain: undefined,
  chainflipId: 'Bitcoin',
} satisfies ChainflipChainData;

export const solana = {
  id: 'sol',
  name: 'Solana',
  addressPlaceholder: '',
  wagmiChain: undefined,
  chainflipId: 'Solana',
} satisfies ChainflipChainData;

export const ethereum = {
  id: 'evm-1',
  name: 'Ethereum',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.mainnet as WagmiChain,
  chainflipId: 'Ethereum',
} satisfies ChainflipChainData;

export const polkadot = {
  id: 'dot',
  name: 'Polkadot',
  addressPlaceholder: '1...',
  wagmiChain: undefined,
  chainflipId: 'Polkadot',
} satisfies AnyChainflipChainData;

export const assethub = {
  id: 'hub',
  name: 'Polkadot',
  addressPlaceholder: '1...',
  wagmiChain: undefined,
  chainflipId: 'Assethub',
} satisfies ChainflipChainData;

export const arbitrum = {
  id: 'evm-42161',
  name: 'Arbitrum',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.arbitrum as WagmiChain,
  chainflipId: 'Arbitrum',
} satisfies ChainflipChainData;

export const tron = {
  id: 'evm-728126428',
  name: 'Tron',
  addressPlaceholder: 'T...',
  wagmiChain: wagmiChains.tron as WagmiChain,
  chainflipId: 'Tron',
} satisfies ChainflipChainData;

export const bsc = {
  id: 'evm-56',
  name: 'BNB Chain',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.bsc as WagmiChain,
  chainflipId: 'Bsc',
} satisfies ChainflipChainData;

export default [bitcoin, solana, ethereum, assethub, arbitrum, tron, bsc];
